import Api from "@src/api";
export const UnitApi= {
  getList(params) {
    return Api().get("UnitMaster",{params});
  },
  getUnitMasterById(id) {
    return Api().get("UnitMaster/" + id);
  },
  updateUnitMaster(data) {
    return Api().put("UnitMaster", data);
  },
  createUnitMaster(data) {
    return Api().post("UnitMaster", data);
  },
  deleteUnitMaster(id) {
    return Api().delete("UnitMaster/" + id);
  },
};
